module.exports = __webpack_public_path__ + "static/media/right-arrow-white.c30ec335.svg";